<template>
  <div style="margin: 0 -5px" class="app-container">
    <div class="fixedButton">
      <vxe-button class="examineButton" @click="ReturnFun">返回</vxe-button>
      <vxe-button v-if="!viewDisabled"  :loading="btnLoading" class="examineButton" status="success" @click="save">保存</vxe-button>
    </div>
    <div class="CertificateReleaseApplicationBox scrollBars" :style="`height:${$store.state.app.height - 70}px;`">
      <div class="main-div">
        <el-form ref="detailForm" class="UniformCss" :inline="true" :model="FormData" label-width="130px" label-position="left">
          <div class="formLine">账期信息</div>
          <div class="budgetBox">
            <el-row :gutter="5">
              <el-col :span="6">
                <el-form-item prop="accountName" :rules="{ required: true, trigger: 'blur' }">
                  <label slot="label"><span>账期名称</span></label>
                  <el-input v-model="FormData.accountName" style="width: 100%" :disabled="viewDisabled" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="预算类型" prop="budgetTypeCode">
                  <el-select v-model="FormData.budgetTypeCode" :disabled="viewDisabled" placeholder="请选择预算类型" @change="changeBudgetType">
                    <el-option v-for="item in SelectLists.PeriodBudgetCode" :key="item.code" :label="item.value" :value="item.code" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="businessCode">
                  <label slot="label"><span>商务政策来源</span><el-tooltip class="item" effect="dark" content="预留字段，与商务政策做关联" placement="top-start">
                    <i class="el-icon-info" style="font-size: 12px; margin-right: 5px; color: #606266" />
                  </el-tooltip></label>
                  <el-input v-model="FormData.businessCode" style="width: 100%" :disabled="viewDisabled" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="status" :rules="{ required: true, trigger: 'blur' }">
                  <label slot="label"><span>状态</span></label>
                  <el-select v-model="FormData.status" placeholder="请选择" :disabled="viewDisabled">
                    <el-option
                      v-for="item in statusOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="有效期-开始时间" prop="beginTime" :rules="{ required: true, trigger: 'blur' }">
                  <el-date-picker
                    v-model="FormData.beginTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    :disabled="viewDisabled"
                    @change="FormData.endTime = ''"
                    style="width: 194px;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="有效期-结束时间" prop="endTime" :rules="{ required: true, trigger: 'blur' }">
                  <el-date-picker
                    v-model="FormData.endTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="{ disabledDate: time => time.getTime() < new Date(FormData.beginTime) }"
                    placeholder="选择日期"
                    :disabled="viewDisabled"
                    style="width: 194px;"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item prop="remark" >
                  <label slot="label"><span>备注</span></label>
                  <el-input v-model="FormData.remark" type="textarea" :rows="3" style="width: 430px" placeholder="请输入" :disabled="viewDisabled" />
                </el-form-item>
              </el-col>
            </el-row>
            <br>
          </div>
        </el-form>
      </div>
      <div>
        <div class="item-linew">经销商费用明细</div>
        <div class="budgetBox" style="margin-top:10px">
          <div v-if="!viewDisabled">
            <vxe-button type="primary"  :disabled="!btnEnable" @click="onAddDealer">添加</vxe-button>
            <vxe-button :loading="deleBtnLoading" type="danger"  :disabled="!btnEnable" @click="onDeleteDealer">删除</vxe-button>
            <vxe-button   :disabled="!btnEnable" @click="batchInputShow = true">
              批量输入
            </vxe-button>
            <vxe-button type="primary" @click="uploadDialog=true">导入</vxe-button>
          </div>
          <div v-else>
            <SiftDealer :base="conditions1">
              <template slot="ButtonTwo">
                <el-form-item style="margin: 10px">
                  <vxe-button style="background: #1b81ef; border: 0px" status="primary" icon="el-icon-search" @click="getAmountDealers(1)">搜索</vxe-button>
                  <vxe-button style="background: #959595; border: 0px" type="primary" icon="el-icon-refresh" @click="clearData">重置</vxe-button>
                </el-form-item>
              </template>
            </SiftDealer>
          </div>
          <div>
            <el-form ref="OBform" label-width="14px">
              <vxe-table
                ref="Xtable"
                :loading="listLoading"
                border
                show-header-overflow
                show-overflow
                class="mytable-scrollbar"
                :column-config="{ resizable: true }"
                stripe
                round
                style="margin-top: 10px"
                :max-height="$store.state.app.height - 300 > 200 ? $store.state.app.height - 200 : 200"
                :scroll-y="{ enabled: false }"
                :row-config="{ isHover: true }"
                :data="dealerList"
              >
                <vxe-column type="checkbox" width="60" align="center" />
                <vxe-column type="seq" title="序号" width="60" align="center" />
                <vxe-column title="经理部" field="sectorName" />
                <vxe-column title="经销商名称" field="dealerName" />
                <!--<vxe-column title="地区" field="address" />-->
                <vxe-column v-if="viewDisabled" title="费用额度(元)" align="right">
                  <template #default="{ row }">
                    <span>{{ row.amount | toThousandNumFilter }}</span>
                  </template>
                </vxe-column>
                <vxe-column v-if="viewDisabled" title="已使用额度(元)" align="right">
                  <template #default="{ row }">
                    <span v-if="row.utilizedAmount != null">{{ row.utilizedAmount | toThousandNumFilter }}</span>
                  </template>
                </vxe-column>
                <vxe-column v-if="viewDisabled" title="备注" field="remark" align="center" />
                <vxe-column v-if="!viewDisabled" title="费用额度(元)" width="180" align="center">
                  <template #default="scope">
                    <el-form-item label=" " :prop="'data.' + (scope.seq - 1) + '.amount'" :rules="[{ required: true, message: '请输入费用额度!', trigger: 'blur' }]">
                      <el-input v-model="scope.row.amount" placeholder="请输入数字" oninput="value=value.replace(/\D/g, '')" />
                    </el-form-item>
                  </template>
                </vxe-column>
                <vxe-column v-if="!viewDisabled" title="备注" width="250" align="center">
                  <template #default="scope">
                    <el-form-item label=" ">
                      <el-input v-model="scope.row.remark" />
                    </el-form-item>
                  </template>
                </vxe-column>
              </vxe-table>
              <vxe-pager
                v-if="viewDisabled"
                style="margin-top: 10px;"
                :current-page="pagination.currentPage"
                :page-size="pagination.pageSize"
                :total="pagination.total"
                :page-sizes="[10, 50, 100, 1000]"
                :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                @page-change="changePage"
              />
            </el-form>
          </div>
          <!--    选择经销商列表-->
          <el-dialog title="选择经销商列表" :visible.sync="showCHD" width="80%" :before-close="back1">
            <div class="usereq">
              <div>
                <el-form :inline="true" style="margin: 0px; height: auto; padding: 0px 10px; vertical-align: middle">
                  <SiftDealer :base="conditions">
                    <template slot="ButtonTwo">
                      <el-form-item style="margin: 10px">
                        <vxe-button style="background: #1b81ef; border: 0px" status="primary" icon="el-icon-search" @click="queryByPage1(1)">搜索</vxe-button>
                        <vxe-button  type="primary" icon="el-icon-refresh" @click="clearData1">重置</vxe-button>
                      </el-form-item>
                    </template>
                  </SiftDealer>
                </el-form>
              </div>
              <el-row :gutter="1">
                <el-col :span="12">
                  <div class="left_content">
                    <vxe-table
                      ref="leftTable"
                      v-loading="leftLoading"
                      border
                      class="mytable-scrollbar"
                      show-header-overflow
                      show-overflow
                      :column-config="{ resizable: true }"
                      stripe
                      round
                      style="margin-top: 10px"
                      max-height="370"
                      :scroll-y="{ enabled: false }"
                      :row-config="{ isHover: true }"
                      :data="leftDealerList"
                      :checkbox-config="selectable"
                    >
                      <vxe-column type="checkbox" width="60" align="center" />
                      <vxe-column type="seq" title="序号" width="60" align="center" />
                      <vxe-column title="经理部" field="sectorName" width="150" />
                      <vxe-column title="经销商名称" field="dealerName" />
                      <!--<vxe-column title="地区" field="address" width="200" />-->
                    </vxe-table>
                    <vxe-pager
                      style="margin-top: 10px;"
                      :current-page="pagination1.currentPage"
                      :page-size="pagination1.pageSize"
                      :total="pagination1.total"
                      :page-sizes="[10, 50, 100, 1000]"
                      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                      @page-change="changePage1"
                    />
                  </div>
                </el-col>
                <el-col :span="1">
                  <div class="move-btn-container">
                    <vxe-button type="primary" icon="el-icon-arrow-right" circle @click="PutDataToRight()" />
                    <vxe-button style="margin: 20px 0 0 0" type="primary" icon="el-icon-arrow-left" circle @click="PutDataToLeft()" />
                  </div>
                </el-col>
                <el-col :span="11">
                  <div class="left_content">
                    <vxe-table
                      ref="rightTable"
                      border
                      class="mytable-scrollbar"
                      show-header-overflow
                      show-overflow
                      :column-config="{ resizable: true }"
                      stripe
                      round
                      style="margin-top: 10px"
                      max-height="370"
                      :scroll-y="{ enabled: false }"
                      :row-config="{ isHover: true }"
                      :data="rightDealerList"
                    >
                      <vxe-column type="checkbox" width="60" align="center" />
                      <vxe-column type="seq" title="序号" width="60" align="center" />
                      <vxe-column title="经理部" field="sectorName" width="150" />
                      <vxe-column title="经销商名称" field="dealerName" />
                      <!--<vxe-column title="地区" field="address" width="200" />-->
                    </vxe-table>
                  </div>
                </el-col>
              </el-row>
              <div class="footer-btn-box">
                <vxe-button @click="back1">关闭</vxe-button>
                <vxe-button status="primary" @click="submit1">确认</vxe-button>
              </div>
            </div>
          </el-dialog>
          <!-- 批量输入 -->
          <el-dialog title="批量输入" :visible.sync="batchInputShow" width="30%">
            <el-form ref="batchInputF" :inline="true" :model="batchData" class="UniformCss" label-width="110px">
              <el-row>
                <el-col>
                  <el-form-item label="费用额度(元):" prop="amount" :rules="[{ required: true, message: '请输入费用额度(元)!', trigger: 'blur' }]">
                    <el-input v-model="batchData.amount" maxlength="13" oninput="value=value.replace(/\D/g, '')" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <vxe-button @click="batchInputShow = false">取 消</vxe-button>
              <vxe-button status="primary" @click="batchInputFun">确 定</vxe-button>
            </span>
          </el-dialog>
          <!--导入对话框 -->
          <el-dialog title="导入Excel" :visible.sync="uploadDialog" width="400px">
            <div v-loading="importLoading" class="faultAdd">
              <div class="model-box">
                <!-- <a class="load-buttom" href="/file/活动下发对象导入模板v2.xlsx" download><i class="el-icon-download" />下载示例模板</a> -->
                <a class="load-buttom" @click="downloadTemplate"><i class="el-icon-download" />下载示例模板</a>
              </div>
              <el-upload ref="upload" class="upload-demo" drag action="" multiple :http-request="upload" :before-upload="uploadBefore" :file-list="fileList">
                <i class="el-icon-upload" />
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div slot="tip" class="el-upload__tip">直接导入已填好的Excel列表，仅支持XLS/XLSX</div>
              </el-upload>
              <div v-if="errorList.length > 0" class="err-box">
                <el-link icon="el-icon-warning" type="danger">Excel导入出错，请检查错误行，然后将错误行重新导入</el-link>
                <div v-for="item in errorList" :key="item.row">
                  <el-link type="danger">第{{ item.row }}行{{ item.error }}</el-link>
                </div>
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import permission from '@/directive/permission/index.js' // 权限判断指令
import { findById, save, findDealers, saveDealerBatch, findAmountDealers, deleteDealerBatch, exportTemp, uploadDealerAmount } from '@/api/amount'
import { findDealerList } from '@/api/base-data'
import SiftDealer from '../components/SiftDealer.vue'
const defaultPagination = {
  total: 0,
  pageSize: 10,
  currentPage: 1
}

const defaultStatusOptions = [
  { value: '1',
    label: '有效'
  },
  {
    value: '0',
    label: '无效'
  }
]
const defaultFormData = {
  id: '',
  amoutName: '',
  beginTime: '',
  endTime: '',
  code: '',
  amount: 0,
  dealerId: '',
  amountType: '',
  dealerName: '',
  remark: '',
  status: '1'
}

export default {
  name: 'DealerAmountMDetail',
  // inject: ['reload'],
  // directives: { permission },
  components: { SiftDealer },
  data() {
    return {
      btnEnable: false,
      FormData: Object.assign({}, defaultFormData),
      listLoading: false,
      statusOptions: Object.assign({}, defaultStatusOptions),
      viewDisabled: false,
      dealerName: '',
      dealerLists: [],
      dealerLoading: false,
      addTablePage: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0
      },
      dealerDialogVisible: false,
      pickerOptionsStart: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      allAlign: 'center',
      pagination: Object.assign({}, defaultPagination),
      dealerList: [], // 已选经销商列表
      showCHD: false, // 选择经销商弹出框
      leftLoading: false, // 左加载
      leftDealerList: [], // （弹出框）经销商列表
      pagination1: {
        total: 0,
        pageSize: 1000,
        currentPage: 1
      },
      conditions: {
        sectorId: null,
        provinceId: null,
        cityId: null,
        dealerName: null
      },
      conditions1: {
        sectorId: null,
        provinceId: null,
        cityId: null,
        dealerName: null
      },
      rightDealerList: [], // （弹出框）已选经销商列表
      selectable: {
        checkMethod: ({ row }) => {
          return !this.rightDealerList.some(i => row.dealerId === i.dealerId)
        }
      },
      batchInputShow: false,
      batchData: {},
      SelectLists: {},
      btnLoading: false,
      deleBtnLoading: false,
      fileList: [],
      uploadDialog: false,
      importLoading: false,
      errorList: []
    }
  },

  watch: {},
  created() {
    if (this.$route.params.id !== 'null') {
      this.FormData.id = this.$route.params.id
      this.btnEnable = true
      this.getDetail()
      this.getAmountDealers(1)
    }
    if (this.$route.params.view === 'view') {
      this.viewDisabled = true
    }
    this.SelectListsFun()
  },
  methods: {
    SelectListsFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['PeriodBudgetCode']).then(v => {
        this.SelectLists = v
      })
    },
    // 点击预算类型
    changeBudgetType(value) {
      const name = this.SelectLists.PeriodBudgetCode.find(item => item.code === value).value
      this.FormData.budgetTypeName = name
    },
    chooseDealer() {
      this.dealerDialogVisible = true
      this.findDealers()
    },
    findDealers() {
      this.dealerLoading = true
      const param = {
        page: this.addTablePage.currentPage,
        limit: this.addTablePage.pageSize,
        paramMap: {
          dealerName: this.dealerName
        }
      }
      findDealers(param).then(res => {
        if (res.code === 1 && res.data) {
          this.dealerLists = res.data.list
          this.addTablePage.totalResult = res.data.total
          this.dealerLoading = false
        }
      })
    },
    handleAddPageChange({ currentPage, pageSize }) {
      this.addTablePage.currentPage = currentPage
      pageSize !== this.addTablePage.pageSize && (this.addTablePage.currentPage = 1)
      this.addTablePage.pageSize = pageSize
      this.findDealers()
    },
    ReturnFun() {
      // this.$deleteBeforeRouter(this)
      // this.$router.push({
      //   name: 'dealerAmountMList'
      // })
      this.$closePage('/terminalActivity/dealerAmountMDetail', '/terminalActivity/dealerAmountMList')

    },
    handleChooseDealer() {
      const data = this.$refs['Xdealer'].getRadioRecord()
      if (data) {
        this.FormData.dealerName = data.name
        this.FormData.dealerId = data.id
      }
      this.dealerDialogVisible = false
    },
    save() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          const params = Object.assign({}, this.FormData)
          save(params).then(res => {
            if (res.code === 1) {
              this.btnLoading = false
              this.$message.success('保存成功')
              if (this.FormData.id) {
                this.saveDealers()
              }
              this.$closePage('/terminalActivity/dealerAmountMDetail', '/terminalActivity/dealerAmountMList')
              // this.$router.push({
              //   // path: `/market_activity/dealerNormalAct/dealerAmountMDetail/${res.data}/edit`
              //   path: `/terminalActivity/dealerAmountMList`
              // })
            }else {
              this.btnLoading = false
              this.$message.warning(res.message)
            }
          })
        } else {
          this.$message.warning('必填项不能为空')
          return
        }
      })
    },
    getDetail() {
      findById(this.FormData.id).then(res => {
        if (res.code === 1) {
          this.FormData = res.data
        }
      })
    },
    changePage(e) {
      if (e) {
        this.pagination.currentPage = e.currentPage
        this.pagination.pageSize = e.pageSize
      }
      this.getAmountDealers(e.currentPage)
    },
    getAmountDealers(n) {
      this.pagination.currentPage = n
      const data = {
        page: this.pagination.currentPage,
        limit: this.pagination.pageSize,
        accountId: this.FormData.id,
        editFlag: '0',
        ...this.conditions1
      }

      if (this.$route.params.view !== 'view') {
        data.limit = 9999
        data.editFlag = '1'
      }

      this.listLoading = true
      findAmountDealers(data).then(res => {
        this.dealerList = res.data.list
        this.pagination.total = res.data.total
        this.listLoading = false
      }).finally(() => this.listLoading = false)
    },
    // 打开经销商列表弹出框
    onAddDealer() {
      this.rightDealerList = this.dealerList
      this.showCHD = true
    },
    // 删除参与经销商
    onDeleteDealer() {
      const selections = this.$refs.Xtable.getCheckboxRecords()
      if (selections && selections.length > 0) {
        this.$confirm({
        title: '即将删除选择的数据, 是否继续?',
        content: '',
        okText: '确定',
        okType: 'primary',
        cancelText: '取消',
        onOk:() => {
          this.deleBtnLoading = true
          this.dealerList = this.dealerList.filter(val => !selections.some(va => va.dealerId === val.dealerId))

          // 获取已保存的数据，后台删除
          const data = selections.filter(val => val.id)

          if (data.length < 1) {
            return
          }

          deleteDealerBatch(data).then(res => {
            if (res.code === 1) {
              this.$message.success('删除成功！')
              this.deleBtnLoading = false
              // this.reload()
            } else {
              this.$message.error(res.message)
            }
          })
        },
        onCancel() {
          console.log('Cancel');
        },
        });
      } else {
        this.$message({ message: '请选择要删除的数据' })
      }
    },
    // （弹出框）获取经销商
    queryByPage1(n) {
      this.leftLoading = true
      this.pagination1.currentPage = n
      const param = {
        page: this.pagination1.currentPage,
        limit: this.pagination1.pageSize,
        ...this.conditions
      }
      findDealerList(param).then(res => {
        if (res.code === 1 && res.data) {
          this.leftLoading = false
          this.leftDealerList = res.data.list
          this.pagination1.total = res.data.total
        }
      })
    },
    changePage1(e) {
      if (e) {
        this.pagination1.currentPage = e.currentPage
        this.pagination1.pageSize = e.pageSize
      }
      this.queryByPage1(e.currentPage)
    },
    clearData() {
      this.conditions1.sectorId = null
      this.conditions1.provinceId = null
      this.conditions1.cityId = null
      this.conditions1.dealerName = null
      this.getAmountDealers(1)
    },
    // 重置条件
    clearData1() {
      this.conditions.sectorId = null
      this.conditions.provinceId = null
      this.conditions.cityId = null
      this.conditions.dealerName = null
      this.queryByPage1(1)
    },
    // 左边经销数据添加到右边
    PutDataToRight() {
      const $leftTable = this.$refs.leftTable
      this.rightDealerList = this.handleConcatArr(this.rightDealerList, $leftTable.getCheckboxRecords())
      $leftTable.clearCheckboxRow() // 清空已选择
    },
    // 右经销商列表数据追加
    handleConcatArr(oldArr, addArr) {
      let newArr = []
      newArr = newArr.concat(addArr, oldArr)
      return newArr
    },
    // 左边经销商数据删除
    PutDataToLeft() {
      const $rightTable = this.$refs.rightTable
      this.handleRemoveTabList($rightTable.getCheckboxRecords(), this.rightDealerList)
      $rightTable.clearCheckboxRow() // 清空已选择
    },
    // 右经销商列表数据移除
    handleRemoveTabList(checkArr, originalArr) {
      for (const item of checkArr) {
        // 已保存的经销商不移除
        if (this.dealerList.some(i => i.id && i.dealerId === item.dealerId)) { continue }
        if (originalArr.indexOf(item) > -1) {
          this.$nextTick(() => {
            originalArr.splice(originalArr.indexOf(item), 1)
          })
        }
      }
    },
    back1() {
      this.showCHD = false
    },
    submit1() {
      // 设置初始值，，防止无法绑定
      this.rightDealerList.forEach(v => {
        if (!v.amount) v.amount = null
      })
      this.dealerList = JSON.parse(JSON.stringify(this.rightDealerList))
      this.showCHD = false
    },
    batchInputFun() {
      this.$refs.batchInputF.validate(v => {
        if (v) {
          const data = this.dealerList
          data.forEach((v, i) => {
            const obj = v
            v.amount || (obj.amount = this.batchData.amount)
            this.$set(data, i, obj)
          })
          this.batchInputShow = false
          this.batchData = {}
        }
      })
    },
    // 保存经销商信息
    saveDealers() {
      if (this.dealerList.length < 1) {
        return
      }
      const data = {
        accountId: this.FormData.id,
        dealers: this.dealerList
      }
      this.btnLoading = true
      saveDealerBatch(data).then(res => {
        if (res.code === 1) {
          this.btnLoading = false
          this.$message.success('保存成功')
          // this.reload()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 下载导入模板
    downloadTemplate() {
      exportTemp({}).then(val => {
        this.$exportExcelData(val, '经销商费用导入模板.xlsx')
      })
    },
    // 上传前对文件的大小的判断
    uploadBefore(file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message('只能上传后缀是.xlsx或者.xls的文件')
        return false
      }

      if (size > 10) {
        this.$message('文件大小不得超过10M')
        return false
      }
    },
    // 上传
    upload(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('accountId', this.FormData.id)
      this.importLoading = true
      uploadDealerAmount(formData).then(res => {
        this.importLoading = false
        if (res.code === 1) {
          this.$message.success('导入成功')
          this.$refs.upload.clearFiles()
          this.importLoading = false
          this.uploadDialog = false
          this.errorList = []
          this.getAmountDealers(1)
        } else {
          this.errorList = res.data
          this.importLoading = false
          this.getAmountDealers(1)
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.el-item-label {
  line-height: 20px;
  display: inline-block;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
}
.formLine {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  background: #4489ce;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.obform-item {
  margin: 0 0 16px 0;
  width: 90%;
  white-space: nowrap;
}
.fixedButton {
  padding: 0px 5px 5px;
  margin: 0 0 5px 0;
  border-bottom: 1px solid rgb(201, 201, 201);
}
.CertificateReleaseApplicationBox {
  width: 100%;
  overflow: auto;
  padding: 0 5px;
}
.move-btn-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 450px;
}
.footer-btn-box {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.err-box {
  margin-top: 10px;
}
/deep/ .el-input__inner {
  height: 30px!important;
}
</style>
